module.exports = __webpack_public_path__ + "img/volume_up_yellow.801cbff8.svg";